// export const baseURL = 'https://www.qhvss.me/kanter/site'
export const baseURL = 'https://www.gcsej.cn/gcsej/site'
// export const baseURL = '/wapp_kanter_war/site' //本地测试环境

// export const path = '/gcsej/site'
// export const path = '/wapp_kanter_war/site' //本地测试环境


//使用D:\dev\node-v14.21.3-win-x64


// WEBPACK FOOTER //
// ./src/utils/url.js